module.exports = __webpack_public_path__ + "img/d-ftop.e12aa93e.jpg";